import React,{ Component } from "react";
import { connect } from "react-redux";
import ConnectionProxyForm from "../ConnectionProxyForm/ConnectionProxyForm";
import { createConnectionProxy } from "../../../actions/actionConnectionProxies";
import { Row, Col, Card, CardHeader, Container} from "reactstrap";
import Proptypes from "prop-types";
import BreadCrumbCompo from "../../../components/Breadcrumb/BreadCrumbCompo";

const routes = [
    {name: "Home",path:"/userdashboard",isActive: false},
    {name: "ConnectionProxy",path:"/connection_proxy",isActive: false},
    {name: "CreateConnectionProxy",path:"/create_connection_proxy",isActive: true},
];

class CreateConnectionProxy extends Component{
    render(){
        return (
            <div>    
                <BreadCrumbCompo routes={routes}/>   
                <Row>
                    <Container>
                        <Col sm={{ size: 8, order: 3, offset: 2 }}>
                            <Card className = "user-form-container">
                                <CardHeader>
                                    <i className="fa fa-edit"></i> <strong>Create Connection Proxy</strong>
                                </CardHeader>
                                <ConnectionProxyForm
                                    createConnectionProxy={this.props.createConnectionProxy}
                                />
                            </Card>
                        </Col>
                    </Container>
                </Row>
            </div>
        );
    }
}

CreateConnectionProxy.propTypes = {
    createConnectionProxy: Proptypes.func.isRequired,
};

export default connect(state => ({
    connection_proxies: state.connection_proxies.connection_proxies || []
}), 
dispatch => ({
    createConnectionProxy: (data) => dispatch(createConnectionProxy(data)),
}))(CreateConnectionProxy);